export default __webpack_public_path__ + "header.e859f49a.mp4";